export function TunnelProgressTestData() {
  let dataDom = [
        {
            "tunnelNumber": "eac218ffa0fe4fcd9c016e0db3889443",
            "pileNoMark": "D1K",
            "invert": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 27.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 27.0,
                "projectName": "仰拱",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "startingMileage": 12700.0,
            "tunnelLength": 200.0,
            "pileNoOrient": "1",
            "showScale": null,
            "tunnelType": "7",
            "excavation": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 195.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 195.0,
                "projectName": "开挖",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "lining": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 21.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 21.0,
                "projectName": "衬砌",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "waterproofTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "excavationTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "tunnelName": "咏思双洞隧道",
            "archBridge": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "liningTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            }
        },
        {
            "tunnelNumber": "5f87d9746ae94f40904e1930e4057f27",
            "pileNoMark": "D1K",
            "invert": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 27.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 27.0,
                "projectName": "仰拱",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "startingMileage": 12700.0,
            "tunnelLength": 200.0,
            "pileNoOrient": "1",
            "showScale": null,
            "tunnelType": "7",
            "excavation": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 195.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 195.0,
                "projectName": "开挖",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "lining": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 21.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 21.0,
                "projectName": "衬砌",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "waterproofTrolley": {
                "distance": 30.0,
                "mileage": 0.0
            },
            "excavationTrolley": {
                "distance": 50.0,
                "mileage": 0.0
            },
            "tunnelName": "咏思双洞隧道",
            "archBridge": {
                "distance": 45.0,
                "mileage": 0.0
            },
            "liningTrolley": {
                "distance": 30.0,
                "mileage": 0.0
            }
        },
        {
            "tunnelNumber": "a1bba0a3541447aeaf40f9a80e882f01",
            "pileNoMark": "D1K",
            "invert": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 27.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 27.0,
                "projectName": "仰拱",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "startingMileage": 12700.0,
            "tunnelLength": 200.0,
            "pileNoOrient": "1",
            "showScale": null,
            "tunnelType": "7",
            "excavation": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 195.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 195.0,
                "projectName": "开挖",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "lining": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 21.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 21.0,
                "projectName": "衬砌",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "waterproofTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "excavationTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "tunnelName": "咏思双洞隧道",
            "archBridge": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "liningTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            }
        },
        {
            "tunnelNumber": "5b6cbe6a38914d06aea5865d3ba7eece",
            "pileNoMark": "D1K",
            "invert": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 27.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 27.0,
                "projectName": "仰拱",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "startingMileage": 12700.0,
            "tunnelLength": 200.0,
            "pileNoOrient": "1",
            "showScale": null,
            "tunnelType": "7",
            "excavation": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 195.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 195.0,
                "projectName": "开挖",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "lining": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 21.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 21.0,
                "projectName": "衬砌",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "waterproofTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "excavationTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "tunnelName": "咏思双洞隧道",
            "archBridge": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "liningTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            }
        },
        {
            "tunnelNumber": "41b03180c25b48fcb5c2021d4e8cf293",
            "pileNoMark": "D1K",
            "invert": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 27.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 27.0,
                "projectName": "仰拱",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "startingMileage": 12700.0,
            "tunnelLength": 200.0,
            "pileNoOrient": "1",
            "showScale": null,
            "tunnelType": "7",
            "excavation": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 195.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 195.0,
                "projectName": "开挖",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "lining": {
                "yearPlan": 0.0,
                "quantity": 200.0,
                "totalCompleted": 21.0,
                "lmPrice": 1.0000,
                "rockSurrounding": "3",
                "monthCompleted": 0.0,
                "lastYearCompleted": 21.0,
                "projectName": "衬砌",
                "monthPlan": 0.0,
                "yearCompleted": 0.0
            },
            "waterproofTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "excavationTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "tunnelName": "咏思双洞隧道",
            "archBridge": {
                "distance": 0.0,
                "mileage": 0.0
            },
            "liningTrolley": {
                "distance": 0.0,
                "mileage": 0.0
            }
        }
    ];



  return dataDom;

}